export const SET_ALERT = 'SET_ALERT'
export const CLOSE_ALERT = 'CLOSE_ALERT'
export const REMOVE_ALERT = 'REMOVE_ALERT'
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS'
export const REGISTER_FAIL = 'REGISTER_FAIL'
export const USER_LOADED = 'USER_LOADED'
export const AUTH_ERROR = 'AUTH_ERROR'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAIL = 'LOGIN_FAIL'
export const LOGOUT = 'LOGOUT'
export const GET_PROFILE = 'GET_PROFILE'
export const GET_PROFILES = 'GET_PROFILES'
export const GET_REPOS = 'GET_REPOS'
export const NO_REPOS = 'NO_REPOS'
export const UPDATE_PROFILE = 'UPDATE_PROFILE'
export const CLEAR_PROFILE = 'CLEAR_PROFILE'
export const PROFILE_ERROR = 'PROFILE_ERROR'
export const ACCOUNT_DELETED = 'ACCOUNT_DELETED'
export const GET_POSTS = 'GET_POSTS'
export const GET_POST = 'GET_POST'
export const POST_ERROR = 'POST_ERROR'
export const UPDATE_LIKES = 'UPDATE_LIKES'
export const DELETE_POST = 'DELETE_POST'
export const ADD_POST = 'ADD_POST'
export const ADD_COMMENT = 'ADD_COMMENT'
export const REMOVE_COMMENT = 'REMOVE_COMMENT'

export const REGISTER_TEACHER_SUCCESS = 'REGISTER_TEACHER_SUCCESS'
export const REGISTER_TEACHER_FAIL = 'REGISTER_TEACHER_FAIL'
export const TEACHER_LOADED = 'TEACHER_LOADED'
export const AUTH_TEACHER_ERROR = 'AUTH_TEACHER_ERROR'
export const LOGIN_TEACHER_SUCCESS = 'LOGIN_TEACHER_SUCCESS'
export const LOGIN_TEACHER_FAIL = 'LOGIN_TEACHER_FAIL'
export const LOGOUT_TEACHER = 'LOGOUT_TEACHER'
export const ACCOUNT_TEACHER_DELETED = 'ACCOUNT_TEACHER_DELETED'

export const GET_PROFILE_TEACHER = 'GET_PROFILE_TEACHER'
export const GET_PROFILE_TEACHER_ERROR = 'GET_PROFILE_TEACHER_ERROR'
export const PROFILE_TEACHER_ERROR = 'PROFILE_TEACHER_ERROR'
export const CLEAR_PROFILE_TEACHER = 'CLEAR_PROFILE_TEACHER'
export const UPDATE_PROFILE_TEACHER = 'UPDATE_PROFILE_TEACHER'

export const FETCH_TEACHERS_SUCCESS = 'FETCH_TEACHERS_SUCCESS'
export const FETCH_TEACHERS_FAIL = 'FETCH_TEACHERS_FAIL '

export const GET_LESSONS = 'GET_LESSONS'
export const CREATE_LESSON = 'CREATE_LESSON'
export const UPDATE_LESSON = 'UPDATE_LESSON'
export const LESSON_ERROR = 'LESSON_ERROR'
export const GET_LESSON = 'GET_LESSON'
export const REMOVE_LESSON = 'REMOVE_LESSON'

export const SET_AVAILABLE_TIME_SUCCESS = 'SET_AVAILABLE_TIME_SUCCESS'
export const SET_AVAILABLE_TIME_ERROR = 'SET_AVAILABLE_TIME_ERROR'
export const GET_CURRENT_AVAILABLE_TIME = 'GET_CURRENT_AVAILABLE_TIME'
export const GET_CURRENT_AVAILABLE_TIME_ERROR =
  'GET_CURRENT_AVAILABLE_TIME_ERROR'

export const BOOK_TIME_SUCCESS = 'BOOK_TIME_SUCCESS'
export const BOOK_TIME_ERROR = 'BOOK_TIME_ERROR'

export const GET_AVAILABLE_TIME_OF_TEACHER_SUCCESS =
  'GET_AVAILABLE_TIME_OF_TEACHER_SUCCESS'
export const GET_CURRENT_AVAILABLE_OF_TEACHER_ERROR =
  'GET_CURRENT_AVAILABLE_OF_TEACHER_ERROR'

export const GET_LESSONS_OF_A_TEACHER_SUCCESS =
  'GET_LESSONS_OF_A_TEACHER_SUCCESS'
export const GET_LESSONS_OF_A_TEACHER_ERROR = 'GET_LESSONS_OF_A_TEACHER_ERROR'

export const CANCEL_BOOKED_LESSON_SUCCESS = 'CANCEL_BOOKED_LESSON_SUCCESS'
export const CANCEL_BOOKED_LESSON_ERROR = 'CANCEL_BOOKED_LESSON_ERROR'

export const CANCEL_BOOKED_LESSON_SUCCESS_TEACHER =
  'CANCEL_BOOKED_LESSON_SUCCESS'
export const CANCEL_BOOKED_LESSON_ERROR_TEACHER = 'CANCEL_BOOKED_LESSON_ERROR'

export const GET_ALL_BOOKED_LESSONS_SUCCESS = 'GET_ALL_BOOKED_LESSONS_SUCCESS'
export const GET_ALL_BOOKED_LESSONS_ERROR =
  'GET_ALL_BOOKED_BOOKED_LESSONS_ERROR'

export const GET_BOOKED_LESSONS_OF_A_TEACHER_SUCCESS =
  'GET_BOOKED_LESSONS_OF_A_TEACHER_SUCCESS'
export const GET_BOOKED_LESSONS_OF_A_TEACHER_ERROR =
  'GET_BOOKED_LESSONS_OF_A_TEACHER_ERROR'

export const GET_BOOKED_LESSON_SUCCESS = 'GET_BOOKED_LESSON_SUCCESS'
export const GET_BOOKED_LESSON_ERROR = 'GET_BOOKED_LESSON_ERROR'

export const GET_PROFILE_TEACHER_BY_ID_SUCCESS =
  'GET_PROFILE_TEACHER_BY_ID_SUCCESS'
export const GET_PROFILE_TEACHER_BY_ID_ERROR = 'GET_PROFILE_TEACHER_BY_ID_ERROR'

export const CONFIRM_BOOKED_LESSON_SUCCESS = 'CONFIRM_BOOKED_LESSON_SUCCESS'
export const CONFIRM_BOOKED_LESSON_ERROR = 'CONFIRM_BOOKED_LESSON_ERROR'

export const GET_PROFILE_STUDENT_BY_ID_SUCCESS =
  'GET_PROFILE_STUDENT_BY_ID_SUCCESS'
export const GET_PROFILE_STUDENT_BY_ID_ERROR = 'GET_PROFILE_STUDENT_BY_ID_ERROR'

export const ADD_REVIEW = 'ADD_REVIEW'
export const GET_REVIEWS = 'GET_REVIEWS'
export const REVIEW_ERROR = 'REVIEW_ERROR'
export const UPDATE_REVIEW = 'UPDATE_REVIEW'
export const DELETE_REVIEW = 'DELETE_REVIEW'

export const SYNC_ORDER_SUCCESS = 'SYNC_ORDER_SUCCESS'
export const SYNC_ORDER_ERROR = 'SYNC_ORDER_ERROR'

export const POST_PROFILE_TEACHER = 'POST_PROFILE_TEACHER'
export const SET_LOADING_TRUE = 'SET_LOADING_TRUE'

export const FETCH_ALL_TEACHERS = 'FETCH_ALL_TEACHERS'
export const FETCH_TEACHERS_BY_SEARCH = 'FETCH_TEACHERS_BY_SEARCH'
export const FETCH_TEACHERS_BY_SEARCH_FAIL = 'FETCH_TEACHERS_BY_SEARCH_FAIL'

export const START_LOADING = 'START_LOADING'
export const END_LOADING = 'END_LOADING'

export const CONFIRM_ORDER_SUCCEEDED_SUCCESS = 'CONFIRM_ORDER_SUCCEEDED_SUCCESS'
export const CONFIRM_ORDER_SUCCEEDED_FAIL = 'CONFIRM_ORDER_SUCCEEDED_FAIL'

export const DELETE_BOOKED_LESSON_BY_ADMIN_SUCCESS = 'DELETE_BOOKED_LESSON_BY_ADMIN_SUCCESS'
export const DELETE_BOOKED_LESSON_BY_ADMIN_ERROR = 'DELETE_BOOKED_LESSON_BY_ADMIN_ERROR'

export const UPDATE_PAID_FOR_TEACHER_STATUS_SUCCESS = 'UPDATE_PAID_FOR_TEACHER_STATUS_SUCCESS'
export const UPDATE_PAID_FOR_TEACHER_STATUS_ERROR = 'UPDATE_PAID_FOR_TEACHER_STATUS_ERROR'

export const SET_UPLOADING_TRUE = 'SET_UPLOADING_TRUE'
export const SET_UPLOADING_FALSE = 'SET_UPLOADING_FALSE'

export const CREATE_COMPLAINT_SUCCESS = 'CREATE_COMPLAINT_SUCCESS'
export const CREATE_COMPLAINT_ERROR = 'CREATE_COMPLAINT_ERROR'

export const ADD_A_AVAILABLE_DURATION = 'ADD_A_AVAILABLE_DURATION'
export const REMOVE_A_AVAILABLE_DURATION = 'REMOVE_A_AVAILABLE_DURATION'
export const FETCH_AVAILABLE_TIME_REQUEST = 'FETCH_AVAILABLE_TIME_REQUEST'